<template>
  <a
    class="col col-sm-12 col-md-6 col-lg-4 teaser--deals"
    :href="baseUrl + (lang === 'de' ? '/angebote/' : '/it/offerte/' ) + item.id + '/'">
    <figure class="figure figure--thumbnail">
      <img
        :src="dealImage(item)"
        width="500"
        height="340"
        loading="lazy"
        class="lazyload"
        :alt="(item.versionFullName) ? item.versionFullName : ''"
      >
    </figure>

    <div class="teaser__content--deals">

      <p class="h4 teaser__title--deals font-weight-bold">{{ (item.versionFullName) ? item.versionFullName : '' }}</p>
      <p class="h4 font-color-secondary">{{ convertToCurrency(item.price) }}</p>

      <p class="title--small">
        {{
          vehicleProperties(item)
        }}
      </p>
    </div>
  </a>
</template>

<script>
import VMixins from "../VMixins/VMixins.vue";

export default {
  name: "VDeal.vue",
  mixins: [VMixins],
  data() {
    return {}
  },

  props: {
    item: Object,
    lexicon: Object
  },
  methods: {
    dealImage(item) {
      let url;
      try {
        url = item.images[0].url
      } catch (e) {
        url = '';
      }
      return url;
    },
    vehicleProperties(item) {
      const transmissionType = `${item.transmissionType ? this.translate('transmissionType', item.transmissionType) : ''}`;
      const fuelType = `${item.fuelType ? this.translate('fuelType', item.fuelType) : ''}`
      const bodyType = `${this.translate('bodyType', item.bodyType)}`
      const horsePower = `${item.horsePower ? item.horsePower + ' ' + this.lexicon.hp : ''}`
      const bodyColor = `${item.BodyColorText ? this.translate('color', item.BodyColorText) : ''}`
      const conditionType = `${this.translate('conditionType', item.conditionType)}`
      const mileage = `${item.mileage} Km`

      return [transmissionType, fuelType, bodyType, horsePower, bodyColor, conditionType, mileage]
      .filter(x  => x !== '')
      .join(' | ')
    },
    translate(key, value) {
      return this.lexicon.interface[`${key}.${value}`] || value
    }
  }
}
</script>
